import Body, { BodyCell } from './Body';
import Header, { Sortable, HeaderCell } from './Header';
import Footer from './Footer';
import Pagination, { PerPage } from './Pagination';
import Row from './Row';
import Table from './Table';

export default Object.assign(Table, {
  Body: Object.assign(Body, {
    Cell: BodyCell,
  }),
  BodyCell,
  Footer,
  Header: Object.assign(Header, {
    Cell: HeaderCell,
    Sortable,
  }),
  HeaderCell,
  Pagination,
  PerPage,
  Row,
});
